import { render, staticRenderFns } from "./deptdevicestatus.vue?vue&type=template&id=130e9ffe&"
import script from "./deptdevicestatus.vue?vue&type=script&lang=js&"
export * from "./deptdevicestatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports